import toError from '@sail/observability/dist/helpers/toError/toError';
import { IntlError, IntlLocaleDataError } from '../../../internal/errors';
export default function handleGlobalizeError(maybeError, reports) {
    var _errorMessage_message_match;
    const errorMessage = toError(maybeError);
    const errorKey = (_errorMessage_message_match = errorMessage.message.match(/^[^:]+/)) === null || _errorMessage_message_match === void 0 ? void 0 : _errorMessage_message_match[0];
    let resultingError;
    switch(errorKey){
        case 'E_INVALID_CLDR':
        case 'E_MISSING_CLDR':
            resultingError = new IntlLocaleDataError(errorMessage.message);
            break;
        default:
            resultingError = new IntlError(errorMessage.message);
    }
    reports.error(resultingError, {
        project: 'sail_core'
    });
    throw resultingError;
}

//# sourceMappingURL=handleGlobalizeError.js.map